const storieSlider = new Swiper(".storie-slider", {
  speed: 500,
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    320: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    600: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    800: {
      slidesPerView: 2.1,
      spaceBetween: 15,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
  },
  loop: true,
  effect: "coverflow",
  coverflowEffect: {
    rotate: 10,
    depth: -100,
    modifier: 1,
    stretch: 1,
    slideShadows: false,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const storieSliderContent = new Swiper(".storie-content-slider", {
  speed: 500,
  slidesPerView: 1,
  spaceBetween: 40,
  // watchSlidesProgress: true,
  watchSlidesVisibility: true,
  slideToClickedSlide: true,
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  thumbs: {
    swiper: storieSlider,
  },
});

storieSlider.on("slideChange", () => {
  const activeIndex = storieSlider.realIndex; // Get active index of the image slider
  if (storieSliderContent.realIndex !== activeIndex) {
    storieSliderContent.slideTo(activeIndex);
  }
});

storieSliderContent.on("slideChange", () => {
  const activeIndex = storieSliderContent.realIndex; // Get active index of the content slider
  if (storieSlider.realIndex !== activeIndex) {
    storieSlider.slideTo(activeIndex);
  }
});

document.querySelectorAll("media-gallery").forEach((gallery) => {
  const thumbnailEl = gallery.querySelector(".product-thumbnails-slider");
  const mainEl = gallery.querySelector(".product-slider");

  if (!mainEl || !thumbnailEl) return;

  const thumbnailNextEl = gallery.querySelector(".product-thumbnails-next") || thumbnailEl.querySelector(".swiper-button-next");
  const thumbnailPrevEl = gallery.querySelector(".product-thumbnails-prev") || thumbnailEl.querySelector(".swiper-button-prev");
  const mainNextEl = gallery.querySelector(".product-slider-next") || mainEl.querySelector(".swiper-button-next");
  const mainPrevEl = gallery.querySelector(".product-slider-prev") || mainEl.querySelector(".swiper-button-prev");

  const thumbnailSwiper = new Swiper(thumbnailEl, {
    slidesPerView: 1,
    speed: 500,
    spaceBetween: 10,
    breakpoints: {
      320: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      660: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      800: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 15,
      },
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    navigation: {
      nextEl: thumbnailNextEl,
      prevEl: thumbnailPrevEl,
    },
  });

  const mainSwiper = new Swiper(mainEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    roundLengths: true,
    observer: true,
    observeParents: true,
    watchOverflow: true,
    thumbs: {
      swiper: thumbnailSwiper,
    },
    navigation: {
      nextEl: mainNextEl,
      prevEl: mainPrevEl,
    },
  });

  mainEl.querySelectorAll("img").forEach((image) => {
    image.addEventListener("load", () => mainSwiper.update(), { once: true });
  });
});

//How it work: Mobile timeline
const featuredTimeLine = new Swiper(".featured-time-line-slider", {
  fadeEffect: { crossFade: true },
  virtualTranslate: true,

  speed: 1000,
  slidersPerView: 1,
  effect: "fade",
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const dealItems = document.querySelectorAll(".deal-feature-item");
const tabContents = document.querySelectorAll(".featured-point-image");

dealItems.forEach((item) => {
  item.addEventListener("click", () => {
    // Remove active class from all tabs and hide all contents
    dealItems.forEach((dealItem) => dealItem.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    // Add active class to clicked tab
    item.classList.add("active");

    // Show the corresponding content
    const tabId = item.getAttribute("data-tab");
    document.getElementById(tabId).classList.add("active");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const guideItems = document.querySelectorAll(".product-guide-content");
  const imageItems = document.querySelectorAll(".product-guide-image-item");

  guideItems.forEach((item) => {
    item.addEventListener("click", () => {
      // Remove active class from all guide items and hide all descriptions
      guideItems.forEach((guideItem) => {
        guideItem.classList.remove("active");
        guideItem.querySelector(".description").style.display = "none";
      });
      // Remove active class from all image items
      imageItems.forEach((imageItem) => imageItem.classList.remove("active"));

      // Add active class to clicked guide item and slide down its description
      item.classList.add("active");
      item.querySelector(".description").style.display = "block";

      // Show the corresponding image
      const tabId = item.getAttribute("data-tab");
      document.getElementById(tabId).classList.add("active");
    });
  });
});

const solutionSlider = new Swiper(".solution-slider", {
  slidesPerView: 1,
  speed: 500,
  spaceBetween: 10,
  // dots: true,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const landScapeSlider = new Swiper(".landscape-slider", {
  slidesPerView: 1,
  speed: 500,
  spaceBetween: 10,
  breakpoints: {
    320: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    592: {
      slidesPerView: 1.2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 1.8,
      spaceBetween: 20,
    },
    1024: {
      slidesPerView: 2.1,
      spaceBetween: 20,
    },
    1280: {
      slidesPerView: 2.5,
      spaceBetween: 20,
    },
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

const planCaretSlider = new Swiper(".plantcare-slider", {
  slidesPerView: 1,
  speed: 500,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: false,
  // },
  // loop: true,
  // observer: true,
  // observeParents: true,
  // observeSlideChildren: true,
});

//kickstart page slider start

// Thumbnail Swiper (for navigation)
var thumbSwiperUnique = new Swiper(".thumb-swiper-unique", {
      loop: true,
      slidesPerView: 'auto',
      spaceBetween: 30,
      //freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 30,
        },
         1200: {
          slidesPerView: 'auto',
          spaceBetween: 40,
        },
      },
    });
  // Main Swiper that syncs with the Thumbnail Swiper
    var mainSwiperUnique = new Swiper(".main-swiper-unique", {
      slidesPerView: 1,
      spaceBetween: 30,
      centeredSlides: true,
      loop: true,
       breakpoints: {
        768: {
          slidesPerView: 1.5,
          spaceBetween: 30,
        }
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
       navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      thumbs: {
        swiper: thumbSwiperUnique,
      },
    });


//kickstart page slider end

(() => {
  const canonicalFlmPath = "/products/flm-001-flow-meter";
  const legacyFlmPaths = ["/products/flm-001", "/products/flm-001-water-flow-meter"];

  const rewriteFlmUrl = (href) => {
    try {
      const url = new URL(href, window.location.origin);

      if (url.origin !== window.location.origin || !legacyFlmPaths.includes(url.pathname)) {
        return null;
      }

      url.pathname = canonicalFlmPath;
      return `${url.pathname}${url.search}${url.hash}`;
    } catch (_error) {
      return null;
    }
  };

  if (legacyFlmPaths.includes(window.location.pathname)) {
    window.location.replace(`${canonicalFlmPath}${window.location.search}${window.location.hash}`);
    return;
  }

  const updateFlmLinks = () => {
    document.querySelectorAll('a[href*="/products/flm-001"]').forEach((link) => {
      const nextHref = rewriteFlmUrl(link.getAttribute("href"));

      if (nextHref) {
        link.setAttribute("href", nextHref);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", updateFlmLinks, { once: true });
  } else {
    updateFlmLinks();
  }

  window.setTimeout(updateFlmLinks, 750);
})();
